import { Tabs, TabsProps } from "antd";
import * as React from "react";
import { classNames } from "src/common/classNames";

import { MfNode, RenderCtx } from "../../node";
import { ZMfNodeTabs } from "../../ZMfNode";
import * as styles from "./MfTabsView.module.less";

type PropsMfTabsView = {
  meta: ZMfNodeTabs;
  ctx: RenderCtx;
  activeKey: string;
  tabNodes: Record<string, MfNode>;
  onActiveChange(newKey: string): void;
};

export const MfTabsView: React.FC<PropsMfTabsView> = (props) => {
  const { meta, ctx, activeKey, tabNodes, onActiveChange } = props;
  const { tabs, verticalFit } = meta;
  const items: TabsProps["items"] = tabs;
  const curNode = tabNodes[activeKey];
  const Render = curNode?.Render;
  return (
    <div className={classNames([[!!verticalFit, styles.vertFit]])}>
      <Tabs
        className={styles.tabs}
        items={items}
        activeKey={activeKey}
        onChange={(newKey) => onActiveChange(newKey)}
      />
      <div className={styles.content}>{Render && <Render ctx={ctx} />}</div>
    </div>
  );
};
